// @flow
import * as ActionTypes from '../../constants/ActionTypes';

export const adminGetInstagramMedia = (shopId, page = 1, limit = 50, filterType = 'all', sortOrder = 'newest', mediaTypeFilter = 'both') => ({
  type: ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_START,
  shopId: shopId,
  page: page,
  limit: limit,
  filterType: filterType,
  sortOrder: sortOrder,
  mediaTypeFilter: mediaTypeFilter,
});

export const adminGetInstagramMediaSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_SUCCESS,
    payload: data,
  };
};

export const adminGetInstagramMediaFailure = (error) => ({
  type: ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_FAILURE,
  payload: error,
});

export const adminGetInstagramMediaStats = (shopId) => ({
  type: ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_STATS_START,
  shopId: shopId,
});

export const adminGetInstagramMediaStatsSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_STATS_SUCCESS,
    payload: data,
  };
};

export const adminGetInstagramMediaStatsFailure = (error) => ({
  type: ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_STATS_FAILURE,
  payload: error,
});

export const adminSyncInstagramMedia = (shopId, accessToken, systemAccountId, mediaLimit = 50) => ({
  type: ActionTypes.ADMIN_SYNC_INSTAGRAM_MEDIA_START,
  shopId: shopId,
  accessToken: accessToken,
  systemAccountId: systemAccountId,
  mediaLimit: mediaLimit,
});

export const adminSyncInstagramMediaSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_SYNC_INSTAGRAM_MEDIA_SUCCESS,
    payload: data,
  };
};

export const adminSyncInstagramMediaFailure = (error) => ({
  type: ActionTypes.ADMIN_SYNC_INSTAGRAM_MEDIA_FAILURE,
  payload: error,
});

export const adminCreateProductsFromInstagram = (shopId, selectedMedia) => ({
  type: ActionTypes.ADMIN_CREATE_PRODUCTS_FROM_INSTAGRAM_START,
  shopId: shopId,
  selectedMedia: selectedMedia,
});

export const adminCreateProductsFromInstagramSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_CREATE_PRODUCTS_FROM_INSTAGRAM_SUCCESS,
    payload: data,
  };
};

export const adminCreateProductsFromInstagramFailure = (error) => ({
  type: ActionTypes.ADMIN_CREATE_PRODUCTS_FROM_INSTAGRAM_FAILURE,
  payload: error,
});

export const adminAddVideoToProduct = (mediaUrl, productId, instagramMediaId) => ({
  type: ActionTypes.ADMIN_ADD_VIDEO_TO_PRODUCT_START,
  mediaUrl: mediaUrl,
  productId: productId,
  instagramMediaId: instagramMediaId,
});

export const adminAddVideoToProductSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_ADD_VIDEO_TO_PRODUCT_SUCCESS,
    payload: data,
  };
};

export const adminAddVideoToProductFailure = (error) => ({
  type: ActionTypes.ADMIN_ADD_VIDEO_TO_PRODUCT_FAILURE,
  payload: error,
});

export const adminUpdateShopFollowers = (shopId, accessToken, systemAccountId) => ({
  type: ActionTypes.ADMIN_UPDATE_SHOP_FOLLOWERS_START,
  shopId: shopId,
  accessToken: accessToken,
  systemAccountId: systemAccountId,
});

export const adminUpdateShopFollowersSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_UPDATE_SHOP_FOLLOWERS_SUCCESS,
    payload: data,
  };
};

export const adminUpdateShopFollowersFailure = (error) => ({
  type: ActionTypes.ADMIN_UPDATE_SHOP_FOLLOWERS_FAILURE,
  payload: error,
});

